
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextSeo } from 'next-seo';
import { GetStaticProps, NextPage } from 'next/types';
import { PAGE } from '../consts/PAGES';
import { getPageById } from '../utils/getPage';
interface IPage {
    page: {
        title: string;
        content: string;
        videos: {
            videos: {
                title: string;
                url: string;
            }[];
        };
        en: {
            title: string;
            content: string;
            videos: {
                videos: {
                    title: string;
                    url: string;
                }[];
            };
        };
    };
}
const PromotionalVideos: NextPage<IPage> = ({ page }) => {
    const VIDEOS = page?.videos?.videos
        ? page?.videos?.videos
        : page?.en.videos.videos;
    return (<>
      <NextSeo languageAlternates={[
            { hrefLang: 'x-default', href: 'https://knsokna.pl/videos' },
            { hrefLang: 'en', href: 'https://knswindows.com/videos/videos' },
            { hrefLang: 'pl', href: 'https://knsokna.pl/videos' },
            { hrefLang: 'de', href: 'https://knsfenster.de/videos' },
            { hrefLang: 'cs', href: 'https://kns-okna.eu/videos' },
            { hrefLang: 'it', href: 'https://knsfinestre.it/videos' },
            { hrefLang: 'fr', href: 'https://knsfenetres.fr/videos' },
            { hrefLang: 'hu', href: 'https://knsokna.eu/videos' },
        ]}/>
      <div className="bg-white">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
          <div dangerouslySetInnerHTML={{ __html: page?.content }}/>
          {VIDEOS.map((video, index) => {
            const url = new URL(video.url || '');
            const videoUrl = url.pathname.substring(1);
            return (<div key={index} className="mb-4 text-center">
                <h3 className="font-bold my-4">{video?.title}</h3>
                <div className="relative h-0 overflow-hidden max-w-7xl mx-auto" style={{ paddingBottom: '56.25%' }}>
                  <iframe width="100%" height="315" src={`https://www.youtube.com/embed/${videoUrl}`} title={video?.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute top-0 left-0 w-full h-full"></iframe>
                </div>
              </div>);
        })}
        </div>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || 'PL';
    const LOCALE = locale === 'cz' ? 'CS' : locale.toUpperCase();
    const PAGE_ID = PAGE.VIDEOS[LOCALE as keyof typeof PAGE.VIDEOS] || 1;
    const { page } = await getPageById(PAGE_ID);
    return {
        props: {
            page,
        },
    };
};
export default PromotionalVideos;

    async function __Next_Translate__getStaticProps__196386c51f6__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/videos',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196386c51f6__ as getStaticProps }
  